module.exports = __webpack_public_path__ + "static/media/masTequila.39442213.jpg";